// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import type { FirebaseApp } from 'firebase/app'
import { getAnalytics, logEvent, setUserId, getGoogleAnalyticsClientId } from 'firebase/analytics'
import type { Analytics } from 'firebase/analytics'
import { bindUserThirdPlatformId } from '@/api/user'
import { REQUEST_SUCCESS_CODE } from '@/config/constant'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'test-project',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
}

// Initialize Firebase (browser only — must also check SSR because vite-ssg mock sets global.window)
let app: FirebaseApp | null = null
let analytics: Analytics | null = null

if (firebaseConfig.apiKey && firebaseConfig.projectId) {
    app = initializeApp(firebaseConfig)
    analytics = getAnalytics(app)
}

/// 统计事件
export function firebase_logEvent(eventName: string, eventValues: Record<string, any> = { platform: 'web' }) {
    if (!analytics) return
    logEvent(analytics, eventName, eventValues)
}

export function firebase_setUserId(userId: string) {
    if (!analytics) return
    setUserId(analytics, userId)
    void syncBindFirebaseClientId()
}

/**
 * 获取 GA4 client_id（Firebase Analytics 与 gtag 共用）
 */
export async function getClientId(): Promise<string> {
    if (!analytics) return ''
    return getGoogleAnalyticsClientId(analytics)
}

/**
 * 登录后将 GA4 client_id 同步到服务端
 */
async function syncBindFirebaseClientId(): Promise<void> {
    try {
        const firebaseClientId = await getGoogleAnalyticsClientId(analytics)
        if (!firebaseClientId) {
            return
        }

        const res = await bindUserThirdPlatformId({ firebaseClientId })
        if (res.code !== REQUEST_SUCCESS_CODE) {
            console.warn('[firebase] bind-user-third-platform-id failed', res.msg || res.code)
        }
    } catch (e) {
        console.warn('[firebase] bind-user-third-platform-id error', e)
    }
}